module.exports = __webpack_public_path__ + "static/media/anquan-logo.2e2356da.svg";